var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "financeApplication__addressSelector" },
    [
      !_vm.submitted
        ? _c(
            "div",
            { staticClass: "financeApplication__addressSelector__input" },
            [
              _c("FinanceApplicationText", {
                attrs: { id: "postcode", placeholder: "Enter Postcode" },
                model: {
                  value: _vm.postcode,
                  callback: function ($$v) {
                    _vm.postcode = $$v
                  },
                  expression: "postcode",
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "financeApplication__addressSelector__button",
                  attrs: {
                    type: "button",
                    disabled: !_vm.isPostcodeValid || _vm.isSubmitting,
                  },
                  on: { click: _vm.submit },
                },
                [_vm._v("\n            Find address\n        ")]
              ),
            ],
            1
          )
        : [
            _c(
              "div",
              { staticClass: "financeApplication__addressSelector__input" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "financeApplication__form__input financeApplication__form__input--select",
                  },
                  [
                    _c(
                      "select",
                      {
                        attrs: { name: "address", id: "" },
                        on: { change: _vm.onAddressChange },
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v("Please select"),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.addressResults, function (address) {
                          return _c(
                            "option",
                            {
                              key: address.id,
                              domProps: { value: address.id },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.formatAddress(address)) +
                                  "\n                    "
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "financeApplication__addressSelector__clear",
                attrs: { type: "button" },
                on: { click: _vm.onClear },
              },
              [_vm._v("\n            Go back to search\n        ")]
            ),
            _vm._v(" "),
            _vm.addressResults.length === 0
              ? _c(
                  "div",
                  {
                    staticClass:
                      "financeApplication__addressSelector__noResults",
                  },
                  [
                    _vm._v(
                      "Sorry, we can't find any results with that postcode."
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "financeApplication__addressSelector__manualAddress",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("show-manual-address-form")
                  },
                },
              },
              [
                _vm._v(
                  "\n            Can't find your address? Click to enter manually.\n        "
                ),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }